import { ButtonHTMLAttributes, PropsWithChildren } from 'react'
import clsx from 'clsx'
import { IconAi } from '../../icons/IconAi'
import styles from './AiButton.module.scss'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'outlined' | 'filled'
  size?: 'sm' | 'md'
  unstyled?: boolean
  indicator?: boolean
}

export const AiButton = ({
  children,
  variant = 'filled',
  size = 'md',
  indicator = false,
  ...buttonProps
}: PropsWithChildren<Props>) => {
  return (
    <div className={clsx(styles.wrapper)}>
      <div className={clsx(styles.indicator, { [styles.active]: indicator })} />
      <div
        className={clsx(styles.container, {
          [styles.disabled]: buttonProps?.disabled,
          [styles.unstyled]: buttonProps?.unstyled,
        })}
      >
        <button
          {...buttonProps}
          className={clsx(styles.button, styles[variant], styles[size])}
          disabled={buttonProps?.disabled}
          type={'button'}
        >
          <div className={clsx(styles.icon, styles[variant], styles[size])}>
            <IconAi color='#00326D' />
          </div>
          {children}
        </button>
      </div>
    </div>
  )
}
